export default __webpack_public_path__ + "static/media/cup-image.5c79217d.png";